import React, { Component } from 'react';
import Radium from 'radium';

import { withStyles } from '@material-ui/core/styles';

import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';


class FeedbackComponent extends Component {

    state = {};

    async handlePost() {
        this.setState({loading: true});
        const {showFeedbackDialog, authorizedUser} = this.props;
        if (!this.state.title || !this.state.description) {
            this.setState({error: true});
            console.log('empty');
            return;
        }
        const requestBody = {
            title: this.state.title,
            description: this.state.description.replace(/\n/g, '\n\n') +
                `\n    ${JSON.stringify(authorizedUser)}`,
        };
        try {
            let resp = await fetch('/api/feedback', {
                credentials: 'include',
                body: JSON.stringify(requestBody),
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
            });
            let json = await resp.json();
            this.setState({loading: false});
            if (json.id) {
              showFeedbackDialog(false);
              this.setState({openSuccessSnackbar: true});
            } else {
              console.log('no result');
              this.setState({error: true})
            }
        } catch (e) {
            console.error(e);
            this.setState({error: true})
        }
    }

    render() {
        const { isFeedbackOpened, showFeedbackDialog } = this.props;

        return (
            <Dialog
              open={isFeedbackOpened}
              onClose={() => showFeedbackDialog(false)}
              aria-labelledby="form-dialog-title"
            >
              <DialogTitle id="form-dialog-title">Отправить отзыв</DialogTitle>
              <DialogContent>
                <DialogContentText>
                {this.state.error ?
                    <Typography color='red'>Произошла ошибка при отправке</Typography> : null
                }
                </DialogContentText>
                <TextField
                  error={this.state.error}
                  value={this.state.title}
                  onChange={(e) => this.setState({title: e.target.value, error: false})}
                  autoFocus
                  margin="dense"
                  id="title"
                  label="Что случилось?"
                  type="text"
                  fullWidth
                  disabled={this.state.loading}
                />
                <TextField
                  error={this.state.error}
                  value={this.state.description}
                  onChange={(e) => this.setState({description: e.target.value, error: false})}
                  id="description"
                  label="Подробное описание:"
                  type="text"
                  fullWidth
                  multiline
                  rows={3}
                  disabled={this.state.loading}
                />
              </DialogContent>
            <DialogActions>
                <Button onClick={() => this.handlePost()} disabled={this.state.loading} color="primary">
                    {this.state.loading ? <CircularProgress size={30} style={{marginRight: 5}}/> : null}
                    {this.state.loading ? 'Подождите...' : 'Отправить'}
                </Button>
            </DialogActions>
            </Dialog>
        )
    }
}

const styles = (theme => ({

  }));

export default Radium(withStyles(styles)(FeedbackComponent))


// WEBPACK FOOTER //
// ./src/FeedbackComponent.js